module.exports = __webpack_public_path__ + "website/img/yoyo14.ba13aa8b.jpg";